$(document).ready(function() {
    //var site_url = "https://www.allaboutcircuits.com";
    //var site_url = "https://aac.webteractive.co";
    var site_url = "";

    var textbook_url = site_url + "/json/worksheets/";
    var textbook_localstorage_key = "aac_textbook_worksheets";
    var textbook_ttl = 21600000; // 6 hour cache

    var textbookUpdater = {
        save: function(data) {
            $.jStorage.set(textbook_localstorage_key, data);
            $.jStorage.setTTL(textbook_localstorage_key, textbook_ttl);
        },
        get: function() {
            return $.jStorage.get(textbook_localstorage_key, 0);
        },
        currentVolume: 0,
        currentChapter: 0,

        addChaptersToVolume: function (volume_json){
            let widget = this;
            $('#textbook_widget_volumes ul li').eq(widget.currentVolume).append('<div id="textbook_widget_chapters" class="w-full flex flex-col lg:absolute left-full top-0 bottom-0 ' + (volume_json.vol_channel_short_name == 'industry_worksheets' ? 'lg:w-[235%]' : 'lg:border-r border-neutral-200') + '"><h3 class="block w-full hidden lg:flex font-bold text-lg p-4 md:p-5">Worksheets</h3><ul class="flex-1 lg:overflow-y-auto relative lg:static"></ul></div>');
            $.each(volume_json.chapters, function (key, chapter) {
                $('#textbook_widget_chapters ul').append('<li class="flex flex-wrap items-center"><a href="/worksheets/' + (volume_json.vol_channel_short_name == 'industry_worksheets' ? volume_json.vol_url_title + '/' : '') + chapter.chapter_url_title + '/" class="ga-link w-full relative flex px-4 py-2 text-sm hover:text-main hover:bg-sub-50 border-transparent ' + (key == 0 ? 'bg-sub-50 text-main current-page' : 'text-sub-900') + ' p-3"><span class="text-base font-bold leading-5 mr-2 px-1.5">' + chapter.chapter_num + '</span>' + chapter.chapter_title + '</a></li>');
            });
        },
        addPagesToChapter: function (volume_json){
                if (volume_json.vol_channel_short_name == 'industry_worksheets'){
                    return;
                }
                let widget = this;
                $('#textbook_widget_chapters ul li').eq(widget.currentChapter).append('<div id="textbook_widget_pages" class="x flex flex-col w-full lg:absolute left-full top-0 bottom-0 lg:w-[135%]"><h3 class="block w-full hidden lg:flex font-bold text-lg p-4 md:p-5">Pages</h3><ul class="flex-1 lg:overflow-y-auto pl-10 lg:pl-0"></ul></div>');
                $.each(volume_json.chapters[widget.currentChapter].pages, function (key, page) {
                    $('#textbook_widget_pages ul').append('<li class="flex flex-wrap items-center border-b border-neutral-200 last:border-b-0"><a href="/worksheets/' + (volume_json.vol_channel_short_name == 'industry_worksheets' ? volume_json.vol_url_title + '/' : '') + volume_json.chapters[widget.currentChapter].chapter_url_title + '/' + (page.page_url_title ? page.page_url_title + '/' : '') + '" class="ga-link block px-4 md:px-5 py-3 text-sm hover:text-main text-sub-900 w-full">' + page.page_title + '</a></li>');
                });
                $('#textbook_widget_pages > ul > li > a').on('click', function () {
                    if (typeof ga === 'function') {
                        ga('send', 'event', "Worksheets Widget", $(this).clone().children().remove().end().text(), $(this).attr('href'));
                    }
                    if (typeof gtag === 'function') {
                        gtag("event", "Worksheets Widget", { event_category: $(this).clone().children().remove().end().text(), event_label: $(this).attr('href') });
                    }
                });
        },
        addChapterClickListeners: function (volume_json){
            let widget= this;
            $('#textbook_widget_chapters > ul > li > a').on('click', function (e) {
                if(volume_json.vol_channel_short_name != 'industry_worksheets'){
                    e.preventDefault();
                    e.stopPropagation();
                    $(this).parent('li').parent('ul').find('li a').each(function () {
                        $(this).removeClass('bg-sub-50 text-main current-page');
                        $(this).addClass('text-sub-900');
                    });
                    $(this).addClass('bg-sub-50 text-main current-page');
                    $(this).removeClass('text-sub-900');

                    let clickedChapter = $(this).parent('li').index();
                    let previousClickedChapter = widget.currentChapter;
                    let checkIfPagesSectionExists = $("#textbook_widget_pages").length;
                    widget.currentChapter = clickedChapter;
                    $('#textbook_widget_pages').remove();
                    if( !$("#menuToggle").is(":visible") || clickedChapter != previousClickedChapter ||  checkIfPagesSectionExists == 0 ) {
                        widget.addPagesToChapter(volume_json);
                    }else{
                        $(this).removeClass('bg-sub-50 text-main current-page');
                        $(this).addClass('text-sub-900');
                    }
                    if ($("#menuToggle").is(":visible")) {
                        $([document.documentElement, document.body]).animate({
                            scrollTop: $("#textbook_widget_chapters ul li").eq(widget.currentChapter).offset().top - 60},
                            300
                        );
                    }
                }
                if (typeof ga === 'function') {
                    ga('send', 'event', "Worksheets Widget", $(this).clone().children().remove().end().text(), $(this).attr('href'));
                }
                if (typeof gtag === 'function') {
                    gtag("event", "Worksheets Widget", { event_category: $(this).clone().children().remove().end().text(), event_label: $(this).attr('href') });
                }
            });
        },
        init: function(json) {
            if($('#textbook_widget_volumes').length > 0) {
                let isMobile = $("#menuToggle").is(":visible");
                let currentChapterLink = $('#textbook_widget_chapters > ul li a.current-page')[0];
                let currentPageLink = $('#textbook_widget_pages > ul li a.current-page')[0];
                let chaptersHeading = $('#textbook_widget_chapters h3')[0];
                let headingOffset = (!isMobile && chaptersHeading) ? chaptersHeading.offsetHeight : 0;
                if (currentChapterLink) {
                    $('#textbook_widget_chapters > ul').scrollTop(currentChapterLink.offsetTop - headingOffset);
                }
                if (!isMobile && currentPageLink) {
                    $('#textbook_widget_pages > ul').scrollTop(currentPageLink.offsetTop - headingOffset);
                }
            }
            let widget = this;
            widget.currentVolume = json.textbook.volumes.findIndex(obj => obj.vol_url_title==$('#textbook_widget_volumes').data('current-volume'));
            if (widget.currentVolume > -1) {
                widget.addChapterClickListeners(json.textbook.volumes[widget.currentVolume]);
            }
            $('#textbook_widget_volumes > ul > li > a').on('click', function (e) {
                e.preventDefault();
                e.stopPropagation();
                $(this).parent('li').parent('ul').find('li a').each(function () {
                    $(this).removeClass('bg-sub-50 text-main current-page');
                    $(this).addClass('text-sub-900');
                });
                $(this).addClass('bg-sub-50 text-main current-page');
                $(this).removeClass('text-sub-900');
                let clickedVolume = $(this).parent('li').index();
                let previousClickedVolume = widget.currentVolume;
                let checkIfChaptersSectionExists = $("#textbook_widget_chapters").length;
                widget.currentVolume = clickedVolume;
                widget.currentChapter = 0;
                $('#textbook_widget_chapters').remove();
                if( !$("#menuToggle").is(":visible") || clickedVolume != previousClickedVolume ||  checkIfChaptersSectionExists == 0 ) {
                    widget.addChaptersToVolume(json.textbook.volumes[widget.currentVolume]);
                    widget.addPagesToChapter(json.textbook.volumes[widget.currentVolume]);
                    widget.addChapterClickListeners(json.textbook.volumes[widget.currentVolume]);
                }else{
                    $(this).removeClass('bg-sub-50 text-main current-page');
                    $(this).addClass('text-sub-900');
                }
                if ($("#menuToggle").is(":visible")) {
                    $([document.documentElement, document.body]).animate({
                            scrollTop: $("#textbook_widget_volumes ul li").eq(widget.currentVolume).offset().top - 60},
                        300
                    );
                }
                if (typeof ga === 'function') {
                    ga('send', 'event', "Worksheets Widget", $(this).clone().children().remove().end().text(), $(this).attr('href'));
                }
                if (typeof gtag === 'function') {
                    gtag("event", "Worksheets Widget", { event_category: $(this).clone().children().remove().end().text(), event_label: $(this).attr('href') });
                }
            });


            $(".textbook-dropdown-button").on("click",function (e){
                e.preventDefault();
                e.stopPropagation();

                let menu = $(this).next("ul");
                let volume = $(this).data("volume");
                let chapter = $(this).data("chapter");
                let page = $(this).data("page");

                $('.textbook-dropdown-button+ul').not(menu).each(function() {
                    $(this).addClass('hidden').removeClass('flex');
                });

                if(page){
                    if (typeof ga === 'function') {
                        ga('send', 'event', "Worksheets - Dropdown", "Pages", "");
                    }
                    if (typeof gtag === 'function') {
                        gtag("event", "Worksheets - Dropdown", { event_category: "Pages", event_label: "" });
                    }
                }else if(chapter){
                    if (typeof ga === 'function') {
                        ga('send', 'event', "Worksheets - Dropdown", "Chapters", "");
                    }
                    if (typeof gtag === 'function') {
                        gtag("event", "Worksheets - Dropdown", { event_category: "Chapters", event_label: "" });
                    }
                }else if(volume){
                    if (typeof ga === 'function') {
                        ga('send', 'event', "Worksheets - Dropdown", "Volumes", "");
                    }
                    if (typeof gtag === 'function') {
                        gtag("event", "Worksheets - Dropdown", { event_category: "Volumes", event_label: "" });
                    }
                }

                if(menu.find("li").length == 0){
                    if (page){
                        $.each(json.textbook.volumes[volume - 1].chapters[chapter - 1].pages, function (key, value) {
                            if(key == 0){
                                // menu.append('<li class="text-xs uppercase text-sub-400 font-bold text-sub-500 px-2 pt-2 pb-1">Pages</li>');
                            }
                            menu.append('<li><a class="px-3 py-0.5 flex flex-col md:flex-row hover:text-main hover:bg-sub-50 w-full text-xs focus:outline-none' + (key == page - 1 ? ' bg-sub-50' : ' text-sub-900') + '" href="/worksheets/' + (json.textbook.volumes[volume - 1].vol_channel_short_name == 'industry_worksheets' ? json.textbook.volumes[volume - 1].vol_url_title + '/' : '') + json.textbook.volumes[volume - 1].chapters[chapter - 1].chapter_url_title + '/' + (value.page_url_title ? value.page_url_title + '/' : '') + '">' + value.page_title + '</a></li>');

                        });
                        menu.find('li a').on('click',function (){
                            if (typeof ga === 'function') {
                                ga('send', 'event', "Worksheets - Dropdown - Pages", $(this).text(), $(this).attr('href'));
                            }
                            if (typeof gtag === 'function') {
                                gtag("event", "Worksheets - Dropdown - Pages", { event_category: $(this).text(), event_label:  $(this).attr('href') });
                            }
                        });
                    }else if(chapter){
                        $.each(json.textbook.volumes[volume - 1].chapters, function (key, value) {
                            if(key == 0){
                                // menu.append('<li class="text-xs uppercase text-sub-400 font-bold text-sub-500 px-2 pt-2 pb-1">Worksheets</li>');
                            }
                            menu.append('<li><a class="px-3 py-0.5 flex flex-col md:flex-row hover:text-main hover:bg-sub-50 w-full text-xs focus:outline-none' + (key == chapter - 1 ? ' bg-sub-50' : ' text-sub-900') + '" href="/worksheets/' + (json.textbook.volumes[volume - 1].vol_channel_short_name == 'industry_worksheets' ? json.textbook.volumes[volume - 1].vol_url_title + '/' : '') + value.chapter_url_title + '/' + (json.textbook.volumes[volume - 1].chapters[value.chapter_num-1].pages[0].page_url_title ? json.textbook.volumes[volume - 1].chapters[value.chapter_num-1].pages[0].page_url_title + '/' : '') + '">' + value.chapter_title + '</a></li>');
                        });
                        menu.find('li a').on('click',function (){
                            if (typeof ga === 'function') {
                                ga('send', 'event', "Worksheets - Dropdown - Chapters", $(this).text(), $(this).attr('href'));
                            }
                            if (typeof gtag === 'function') {
                                gtag("event", "Worksheets - Dropdown - Chapters", { event_category: $(this).text(), event_label:  $(this).attr('href') });
                            }
                        });
                    }else if(volume){                            
                        let prev_volume_name = "";
                        let current_volume_name = "";
                        $.each(json.textbook.volumes, function (key, value) {
                            current_volume_name = value.vol_channel_short_name == "industry_worksheets" ? "Worksheets" : "Industry Worksheets"
                            if(prev_volume_name != current_volume_name){
                                menu.append('<li class="text-xs uppercase font-bold text-sub-900 px-3 py-0.5">' + current_volume_name + '</li>');
                                prev_volume_name = current_volume_name;
                            }
                            menu.append('<li><a class="px-3 py-0.5 flex flex-col md:flex-row hover:text-main hover:bg-sub-50 w-full text-xs focus:outline-none' + (key == volume - 1 ? ' bg-sub-50' : ' text-sub-900') + '" href="/worksheets/">' + value.vol_title.replace(/^(Vol\. .*-)/i,"") + '</a></li>');
                        });
                        menu.find('li a').on('click',function (){
                            if (typeof ga === 'function') {
                                ga('send', 'event', "Worksheets - Dropdown - Volumes", $(this).text(), $(this).attr('href'));
                            }
                            if (typeof gtag === 'function') {
                                gtag("event", "Worksheets - Dropdown - Volumes", { event_category: $(this).text(), event_label:  $(this).attr('href') });
                            }
                        });
                    }
                }
                menu.toggleClass("hidden").toggleClass('flex');
            });
            $(document).click(function() {
                $('.textbook-dropdown-button+ul').each(function() {
                    $(this).addClass('hidden').removeClass('flex');
                });
            });
        },
    };
    var textbook_json = textbookUpdater.get();
    if (textbook_json === 0) {
        $.getJSON(textbook_url, function(textbook_json) {
            if (parseInt(textbook_json.status) === 200) {
                textbookUpdater.save(textbook_json);
                textbookUpdater.init(textbook_json);
            }
        });
    } else {
        textbookUpdater.init(textbook_json);
    }

});